// Example Element Types

// Marker coordinate (pixel position on original image)
export interface MarkerCoordinate {
  x: number;
  y: number;
}

// Pan offset (additional offset from auto-centered position)
export interface PanOffset {
  x: number;
  y: number;
}

// Default zoom level (25% zoom for reports)
export const DEFAULT_ZOOM = 0.25;

export interface ExampleConfig {
  header?: string;                    // Editable header (displayed above images)
  caption: string;                    // Editable text caption
  beforeImageUrl: string;             // Before image URL (original/annotated for pan/zoom)
  afterImageUrl: string;              // After image URL (original/annotated for pan/zoom)
  // Viewer URLs for opening in new tab
  compareViewerUrl?: string;          // Compare viewer URL
  // Crop center positions - ORIGINAL coordinates for image centering (stable, never change during drag)
  beforeCropCenter?: MarkerCoordinate;  // Where to center the before image crop
  afterCropCenter?: MarkerCoordinate;   // Where to center the after image crop
  // Marker positions - EXPLICIT marker overlay position (can be moved by user)
  beforeMarker?: MarkerCoordinate;    // Marker position on before image (defaults to cropCenter)
  afterMarker?: MarkerCoordinate;     // Marker position on after image (defaults to cropCenter)
  // Pan offsets (user adjustment from auto-centered position)
  beforePanOffset?: PanOffset;        // Pan offset for before image
  afterPanOffset?: PanOffset;         // Pan offset for after image
  // Zoom levels (independent for each image, default 0.75)
  beforeZoom?: number;
  afterZoom?: number;
  // Current crop URLs (updated live as user zooms/pans, EXACT URLs to be stored in DB)
  beforeCropUrl?: string;             // Current before image crop URL (matches Copy URL button)
  afterCropUrl?: string;              // Current after image crop URL (matches Copy URL button)
  // Cropped versions (for backward compatibility - deprecated)
  beforeCroppedUrl?: string;
  afterCroppedUrl?: string;
  beforeCroppedMarker?: MarkerCoordinate;
  afterCroppedMarker?: MarkerCoordinate;
  // Metadata
  companySlug?: string;               // Company for linking
  companyName?: string;               // Display name
  eventType?: string;                 // e.g., "price_increased"
  eventId?: string;                   // Original event ID
  period?: string;                    // e.g., "2025Q4"
  // Version identifiers (e.g., "20251004" date format)
  beforeVersion?: string;             // Before screenshot version/date
  afterVersion?: string;              // After screenshot version/date
}

export interface ExampleElementContent {
  config: ExampleConfig;
}

// Example Table Element Types - table of text rows (no images)
export interface ExampleTableRow {
  id: string;                         // Unique row ID
  period: string;                     // Quarter (e.g., "2025Q4")
  companyName: string;                // Company display name
  companySlug?: string;               // Company slug for linking
  eventType: string;                  // Change type (e.g., "price_increased")
  description: string;                // Editable description
  compareViewerUrl?: string;          // View link URL
  sharedLinkId?: string;              // Shared link ID (for updating campaign fields)
  eventId?: string;                   // Original event ID
  annotation?: any;                   // Stored event annotation for link regeneration
  combined_annotation?: any;          // Stored diff-level annotation for link regeneration
  icon_url?: string;                  // Icon URL for the event type
}

export interface ExampleTableConfig {
  title: string;                      // Editable table title
  rows: ExampleTableRow[];            // Table rows
}

export interface ExampleTableElementContent {
  config: ExampleTableConfig;
}
